<template>
    <b-row>
        <Sidebar/>
        <b-col md="10" offset-md="2">
            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 class="h2" v-for="user in users">{{user.name}}</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                    <div class="btn-group mr-2">
                        <b-button variant="outline-secondary" to="/usuarios/nuevo">Nuevo</b-button>
                        <b-button variant="outline-primary" :to="'/usuarios/editar/' + this.$route.params.id">Editar</b-button>
                    </div>
                </div>
            </div>
            <p v-if="isLoading">Cargando...</p>
            <b-list-group v-else v-for="(user, key) in users" v-bind:key="key">
                <b-list-group-item><b>Nombre:</b><span>{{user.first_name}}</span></b-list-group-item>
                <b-list-group-item><b>Apellido(s):</b><span>{{user.last_name}}</span></b-list-group-item>
                <b-list-group-item><b>Email:</b><span>{{user.email}}</span></b-list-group-item>
                <b-list-group-item><b>Usuario:</b><span>{{user.username}}</span></b-list-group-item>
                <b-list-group-item><b>RUT:</b><span>{{user.rut}}</span></b-list-group-item>
                <b-list-group-item><b>Rol:</b><span>{{user.rol}}</span></b-list-group-item>
                <b-list-group-item><b>Estado:</b><span>{{isActive}}</span></b-list-group-item>
            </b-list-group>

        </b-col>
    </b-row>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: "UsersView",
        data() {
            return {
                isLoading: true
            }
        },
        computed: {
            ...mapGetters({
                users: 'users/getUsers',
                isActive: 'users/isActive'
            })
        },
        created() {
            this.$store.dispatch('users/loadSingleUser', this.$route.params.id ).then(() => {
                this.isLoading = false;
            });
        }
    }
</script>